import { Mail } from "lucide-react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-[hsl(var(--footer-gradient-start))] via-[hsl(var(--footer-gradient-mid))] to-[hsl(var(--footer-gradient-end))] text-foreground py-12 border-t border-border shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Logo principal */}
          <div className="mb-8 flex justify-center">
            <img
              src="/lovable-uploads/0a2e8650-8225-49f1-bafc-4390e4d31d40.png"
              alt="El Principio Cine y Cultura A.C."
              className="h-48 sm:h-56 md:h-64 w-auto"
            />
          </div>

          <div className="mb-10">
            <Link
              to="/contacto"
              className="inline-flex items-center space-x-2 bg-golden hover:bg-brand text-golden-foreground hover:text-brand-foreground px-8 py-3 rounded-full transition-all duration-300 shadow-md hover:shadow-lg font-medium"
            >
              <Mail size={20} />
              <span>Contacto</span>
            </Link>
          </div>

          {/* Pleca institucional */}
          <div className="mb-5 flex flex-col items-center">
            <p className="text-sm md:text-base text-muted-foreground mt-10 mb-0 px-4 text-center">
              PROYECTO REALIZADO CON EL APOYO DEL INSTITUTO MEXICANO DE CINEMATOGRAFÍA
              <br />A TRAVÉS DEL PROGRAMA FOMENTO AL CINE MEXICANO (FOCINE).
            </p>
            <img
              src="/lovable-uploads/pleca-focine-color.png"
              alt="Cultura, IMCINE, FOCINE"
              className="mt-1 w-full max-w-3xl h-auto px-4"
            />
          </div>

          <div className="border-t border-border pt-8">
            <p className="text-muted-foreground text-sm">
              © 2025 El Principio Cine y Cultura, A.C. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
